// extracted by mini-css-extract-plugin
export var footer = "_pg-5";
export var fulfillmentInput = "_pg-0";
export var shipDateInput = "_pg-1";
export var shipmentModal = "_pg-2";
export var shipmentModalContent = "_pg-3";
export var tableContainer = "_pg-4";